import { Navigate } from 'react-router'

import { ROUTES } from '@/router'
import { TLoginType } from '@/typings'
import { ID_TOKEN, LOGIN_TYPE } from '@/utils/constant/storage'

interface Props {
  children: React.ReactElement
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const token = localStorage.getItem(ID_TOKEN)
  const loginType = localStorage.getItem(LOGIN_TYPE)

  if (!token && loginType !== TLoginType.THIRD_PARTY) {
    return <Navigate to={ROUTES.SIGN_IN} />
  }

  return children
}

export default ProtectedRoute
